var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-timer"},[_c('img',{attrs:{"src":require("../../assets/img/detail/sale_item.png"),"class-name":"img-100"}}),_c('timer-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }